module.exports = __webpack_public_path__ + "static/media/refresh.5c633b1e.svg";